import wayPointFromJson from "../waypoint/mapper";
import CustomRouteData from "./data";

export default function customRouteFromJson(json) {
    return new CustomRouteData(
        json.id,
        json.theyr_id,
        json.route_points.map((point) => wayPointFromJson(point)),
        json.description,
        json.created_at,
        json.verified
    )
}